<template>
    <div>
        <div class="form-group">
            <div id="loader" v-if="isLoading">
                <div class="spinner"></div>
            </div>

        </div>
        <div class="form-group mt-5">
            <div class="form-check">
                <input
                    data-test="terms-and-conditions-checkbox"
                    type="checkbox"
                    id="terms_conditions"
                    class="form-check-input"
                    name="terms_and_conditions"
                    v-model="formRef.terms_and_conditions"
                    required
                />
                <label class="form-check-label form-label" for="terms_conditions">
                    I agree to the &nbsp;<a
                        href="https://www.kingstrust.org.uk/privacy-notice/website-terms-and-conditions"
                        target="_blank"
                        >King's Trust Website Terms and Conditions
                        <i class="fas fa-asterisk"></i
                    ></a>
                </label>
                <br/>
                <span
                    data-test="terms-and-conditions-error-span"
                    class="enquiry-errors"
                    v-if="formRef.errors.has('terms_and_conditions')"
                    v-text="formRef.errors.get('terms_and_conditions')"
                    role="alert"
                    aria-live="assertive"
                ></span>
            </div>
        </div>

        <div class="form-group mt-5">
            <h3>Your Privacy Matters</h3>
            <h5>
                When you share your details with us, we will keep a digital
                record to:
            </h5>
            <ul>
                <li>Support you and respond to your request</li>
                <li>Keep a note of any activities you take part in with us</li>
                <li>Meet our legal duties and requirements of our funders</li>
                <li>
                    Send you useful updates and information about this programme
                </li>
                <li>Improve our services and support</li>
                <li>
                    Report to our funders (without identifying you personally
                    unless the law says we must).
                </li>
            </ul>
            <h5>
                We will only keep your information for as long as we need for
                these reasons.
            </h5>
            <h5>
                You can read more in our
                <a
                    href="https://www.kingstrust.org.uk/privacy-notice/young-people-privacy-notice"
                    target="_blank"
                    >Young People Privacy Notice</a
                >
            </h5>

            <div class="form-check mt-3">
                <input
                    data-test="privacy-policy-consent-checkbox"
                    type="checkbox"
                    id="privacy_policy_consent"
                    class="form-check-input"
                    name="privacy_policy_consent"
                    v-model="formRef.privacy_policy_consent"
                    required
                />
                <label
                    class="form-check-label form-label"
                    for="privacy_policy_consent"
                >
                    I agree to the King's Trust collecting and using my
                    information in the ways explained above.
                    <i class="fas fa-asterisk"></i>
                </label>
                <br/>
                <span
                    data-test="privacy-policy-error-span"
                    class="enquiry-errors"
                    v-if="formRef.errors.has('privacy_policy_consent')"
                    v-text="formRef.errors.get('privacy_policy_consent')"
                    role="alert"
                    aria-live="assertive"
                >
                </span>
            </div>
        </div>
        <div class="form-group mt-5">
            <h3>Young person Code of Conduct</h3>
             <h5>Please read our Young Person Code of Conduct to understand how you can help us build a safe and positive experience for everyone at The King’s Trust.</h5>

            <h5>This includes:</h5>
            <ul>
                 <li>what you can do to support a safe and positive experience for everyone</li>
                 <li>what you can expect from us, so you can let us know if any of our staff, young people or volunteers are behaving in a way that doesn’t feel right.</li>
            </ul>
            <div class="form-check">
                <input
                    data-test="code-of-conduct-checkbox"
                    type="checkbox"
                    id="code_of_conduct"
                    class="form-check-input"
                    name="code-of-conduct"
                    v-model="formRef.code_of_conduct"
                    required
                />
                <label class="form-check-label form-label" for="code-of-conduct">

                    I agree to meet the expectations set out in the <a
                        href="https://my.kingstrust.org.uk/code-of-conduct"
                        target="_blank"
                        >Young Person Code of Conduct
                        <i class="fas fa-asterisk"></i
                    ></a>
                </label>
                <br />
                <span
                    data-test="code-of-conduct-error-span"
                    class="enquiry-errors"
                    v-if="formRef.errors.has('code_of_conduct')"
                    v-text="formRef.errors.get('code_of_conduct')"
                    role="alert"
                    aria-live="assertive"
                ></span>
            </div>
        </div>

        <div class="form-group mt-5">
            <fieldset>
                <legend>
                    <h3>Would you like to hear more from us?</h3>
                    <h5>Want to get updates about new King’s Trust courses and programmes that we think you might be interested in? Let us know how you would like us to contact you.</h5>
                </legend>
                <p class="small">(Choose one or more)</p>
                <div class="form-check">
                    <input
                        data-test="contact-by-phone-checkbox"
                        type="checkbox"
                        id="contact_by_phone"
                        class="form-check-input"
                        name="contact_by_phone"
                        v-model="formRef.contact_by_phone"
                    />
                    <label for="contact_by_phone" class="form-label"> By phone </label>

                    <br/>
                    <input
                        type="checkbox"
                        id="contact_by_text"
                        class="form-check-input"
                        name="contact_by_text"
                        v-model="formRef.contact_by_text"
                    />
                    <label for="contact_by_text" class="form-label"> By text </label>
                    <br/>
                    <input
                        type="checkbox"
                        id="contact_by_email"
                        class="form-check-input"
                        name="contact_by_email"
                        v-model="formRef.contact_by_email"
                    />
                    <label for="contact_by_email" class="form-label"> By email </label>
                    <br/>
                    <input
                        type="checkbox"
                        id="contact_by_post"
                        class="form-check-input"
                        name="contact_by_post"
                        v-model="formRef.contact_by_post"
                    />
                    <label for="contact_by_post" class="form-label"> By post</label>
                    <br/>
                </div>
            </fieldset>
        </div><br>
        <h3>Create password</h3>
        <h5>We’ll use this password to set you up with an account on the My King’s Trust website.</h5>
        <h5>Your password must contain at least:</h5>
        <ul>
            <li>8 characters</li>
            <li>A lower case letter</li>
            <li>An upper case letter</li>
            <li>A number</li>
            <li>A special character e.g. !@&£</li>
        </ul>

        <div class="form-group">
            <div class="col-lg-6 px-0 mt-4">
                <label for="password" class="form-label">
                    <b>Create password <i class="fas fa-asterisk"></i></b
                ></label>
                <input
                    data-test="password-input"
                    id="password"
                    type="password"
                    name="password"
                    v-model="formRef.password"
                    class="form-control"
                    required
                />
                <span
                    data-test="password-error-span"
                    class="enquiry-errors"
                    v-if="formRef.errors.has('password')"
                    v-text="formRef.errors.get('password')"
                    role="alert"
                    aria-live="assertive"
                ></span>
            </div>
        </div>
        <div class="form-group">
            <div class="col-lg-6 px-0 mt-4">
                <label for="password_confirmation" class="form-label"
                    ><b>Confirm password <i class="fas fa-asterisk"></i></b>
                </label>
                <input
                    data-test="password-confirmation-input"
                    id="password_confirmation"
                    type="password"
                    name="password_confirmation"
                    v-model="formRef.password_confirmation"
                    class="form-control"
                    required
                />
            </div>
            <span
                class="enquiry-errors"
                v-if="formRef.errors.has('password_confirmation')"
                v-text="formRef.errors.get('password_confirmation')"
                role="alert"
                aria-live="assertive"
            ></span>
        </div>
        <div class="form__buttons form-group py-3">
            <button
                type="button"
                class="btn btn-secondary me-2"
                @click.prevent="goBack()"
                data-test="btn-back"
            >
                Go back
            </button>
            <button
                class="btn btn-primary"
                @click.prevent="nextPage()"
                data-test="btn-next"
            >
                Confirm
            </button>
            <span
                data-test="terms-conditions-error"
                class="enquiry-errors d-block mt-2"
                v-if="formRef.errors?.get('formStatus')"
            >
                {{ formRef.errors.get("formStatus") }}
            </span>
        </div>
    </div>
</template>

<script setup>
import Form from "../../../../Form.js";
import axios from "axios";
import { ref, markRaw } from "vue";

const props = defineProps({
    step: Number,
    formData: Object
})

const emit = defineEmits(['goBackAStep', 'submitButton'])

let formRef = markRaw(ref(new Form({
    password: null,
    password_confirmation: null,
    code_of_conduct: null,
    terms_and_conditions: null,
    privacy_policy_consent: null,
    contact_by_text: null,
    contact_by_phone: null,
    contact_by_email: null,
    contact_by_post: null
}, props.formData)))

const isLoading = ref(false)

function goBack() {
    emit("goBackAStep");
}

function nextPage() {
    isLoading.value = true
    return axios
        .post("/registration/step4", formRef.value.data())
        .then(() => {
            emit("submitButton", {
                data: {
                    password: formRef.value.password,
                    password_confirmation: formRef.value
                        .password_confirmation,
                    code_of_conduct: formRef.value.code_of_conduct,
                    terms_and_conditions: formRef.value
                        .terms_and_conditions,
                    privacy_policy_consent: formRef.value
                        .privacy_policy_consent,
                    contact_by_text: formRef.value.contact_by_text,
                    contact_by_phone: formRef.value.contact_by_phone,
                    contact_by_email: formRef.value.contact_by_email,
                    contact_by_post: formRef.value.contact_by_post
                }
            });
        })
        .catch((err) => {
            if (err.response && err.response.status === 400 && err.response?.data?.error?.code === "OKTA_ACCOUNT_EXISTS") {
                window.location.href = "/error/account-exists";
                return;
            }

            if (err.response && err.response.status === 422) {
                formRef.value.errors.record(err.response.data.errors);
            } else if (err.response.data.message) {
                formRef.value.errors.record({
                    'formStatus': err.response.data.message
                });
            }
            else {
                window.location.href = "/site-error"
            }
        })
        .finally(() => (isLoading.value = false));
}
</script>
